export default __webpack_public_path__ + "static/media/morningIcon.aed467ef.svg";